import React, { FunctionComponent } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { financialItemStyles } from "./financialItemStyle";
import { Grid, Typography } from "@material-ui/core";
import "../Print.css";

type CashierDataProps = {
  cashierData: Array<object>;
  cashierTotal: string;
};
export const CashierSales: FunctionComponent<CashierDataProps> = ({
  cashierData,
  cashierTotal,
}) => {
  const classes = financialItemStyles();
  return (
    <Grid container>
      <Grid item xs={12}>
        <TableContainer>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead className={classes.tableRow} style={{ height: "4em" }}>
              <TableRow style={{ height: "3em" }}>
                <TableCell
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  style={{ width: "35%" }}
                >
                  Cashier Name
                </TableCell>
                <TableCell className={classes.deptHead} align="center">
                  Number of Transactions
                </TableCell>
                <TableCell align="right" className={classes.headColor}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cashierData &&
                cashierData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.columnWeight}>
                      {data.full_name}
                    </TableCell>
                    <TableCell align="center" className={classes.tableContent}>
                      {data.total_bill_count}
                    </TableCell>
                    <TableCell align="right" className={classes.columnWeight}>
                      {data.total_system_amount_sum}
                    </TableCell>
                  </TableRow>
                ))}

              <TableRow style={{ height: "3em" }}>
                <TableCell align="left" className={classes.totalCellStyle}>
                  <Typography className={classes.total}>Total</Typography>
                </TableCell>
                <TableCell align="left" className={classes.middleTotalcell} />
                <TableCell align="right" className={classes.totalValueCell}>
                  <Typography className={classes.value}>
                    {cashierTotal}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {/* <Grid item xs={12}>
        <Grid container>
          <Grid item xs={6}>
            <Typography className={classes.total}>Total</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.value}>{departmentTotal}</Typography>
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
};
